<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
        title="意见反馈"
        right-text="提交"
        fixed
        :z-index="99"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        :border="false"
     />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <div class="tips-panel">
        <div class="hlight title">有您，我们会做得更好!</div>
        <p class="details">为给广大用户提供更加完善、便捷的网上祭祀服务，打造全球最好的祭祀平台，我们深知，孝恩天堂的每-次进步都是来自广大用户您们的参与和支持!为此，特征集您对孝恩天堂服务体验的评价，说出您对该网的意见和建议，假如有些地方我们做得不够好，请您批评指正。这些都将是孝恩天堂前进的动力!</p>
      </div>
      <van-cell-group>
        <van-field
          v-model="title"
          placeholder="标题"
        />
        <van-field
          v-model="message"
          rows="8"
          autosize
          type="textarea"
          maxlength="150"
          placeholder="宝贵意见..."
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
	export default {
	  data() {
	    return {
	    	title:'',
        message:'',
        issubmit: false,
	    };
	  },
	  components: {
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
    },
    beforeDestroy() {
      document.querySelector('body').removeAttribute('style')
    },
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
			},
      onClickRight(){
        var that = this;
        if(that.title == ''|| that.title.length == 0){
          Toast('标题不能为空！');
          return;
        }
        if(that.message == ''|| that.message.length == 0){
          Toast('内容不能为空！');
          return;
        }
        if(!that.issubmit){
          that.issubmit = true;
          this.$store.dispatch({
            type:"GenericArticleAddFeedbackVue",
            title:that.title,
            content:  that.message,
          }).then(res => {
            setTimeout(function (){
              that.issubmit = false;
              that.$router.go(-1);
            }, 2000);
            if(res.IsSuccess){
              Toast(res.Message);
            }
          }, err => {that.issubmit = false;})
        }
        
      }
		},
	};
</script>

<style scoped>
.tips-panel{
  padding: 30px;
  margin-bottom: 10px;
  background-color: #fff;
}
.tips-panel>.title{
  font-size: 18px;
  text-align: center;
  font-weight: normal;
  margin-bottom: 15px;
}
.tips-panel>.details{
  font-size: 14px;
  color: #555;
}
</style>
